import React from 'react';

const baseClasses = 'text-sm font-medium u-ink-800 leading-none';

export const Label = React.forwardRef(function Label({ className = '', ...props }, ref) {
  const classes = [baseClasses, className].filter(Boolean).join(' ');
  return <label ref={ref} className={classes} {...props} />;
});

Label.displayName = 'Label';

export default Label;
